import { render, staticRenderFns } from "./CookieIcon.vue?vue&type=template&id=876d3060&"
import script from "./CookieIcon.vue?vue&type=script&lang=js&"
export * from "./CookieIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports